import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';

import { IntegrationEspEloquaData } from './Data';

export interface IntegrationEspEloquaState extends BaseIntegrationState {
  endpoint?: string;
  purl?: boolean;
}

export class IntegrationEspEloquaModel extends BaseIntegration<IntegrationEspEloquaData, IntegrationEspEloquaState> {
  parse(data: IntegrationEspEloquaData) {
    super.parse(data);
    this.state.endpoint = data.settings?.endpoint;
    this.state.purl = !!data.settings?.purl;
  }

  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/esp/eloqua/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Dannie Hansen';
  }
}
